import React from 'react'
import watertechbasin from "../images/watertecbasin.png";
import watertechbath from "../images/watertechbath.png";
import watertech from "../images/watertecuma.10.png";
import watertechproduct from "../images/watertec..png"
import watertechproducts from "../images/watertecshower.png"
import watertechproductsnew from "../images/umahardwarewatertec..png";
import watertehnew from "../images/umahardwareproduct..png"

function Watertec() {
    return (
        <div>
            <div className="album py-2">
                <div className="container">
                    <div className="row">
                        <div className="col-md-4 mt-2">
                            <div className="card">
                                <img src={watertechbasin} className="card-img-top" alt="watertechbasin"/>
                                <div className="card-body">
                                    <h5 className="card-title mb-1">WATER TEC</h5>
                                    <p>Availabe at Uma Hardware</p>
                                    <a style={{color:"white"}} href="Watertec" className="callnow">Call Now</a>
                                </div>
                            </div>
                        </div>
                         <div className="col-md-4 mt-2">
                            <div className="card">
                                <img src={watertechbath} className="card-img-top" alt="watertechbath"/>
                                <div className="card-body">
                                    <h5 className="card-title mb-1">WATER TEC</h5>
                                    <p>Availabe at Uma Hardware</p>
                                    <a style={{color:"white"}} href="Watertec" className="callnow">Call Now</a>
                                </div>
                            </div>
                        </div>
                         <div className="col-md-4 mt-2">
                            <div className="card">
                                <img src={watertech} className="card-img-top" alt="watertech"/>
                                <div className="card-body">
                                    <h5 className="card-title mb-1">WATER TEC</h5>
                                    <p>Availabe at Uma Hardware</p>
                                    <a style={{color:"white"}} href="Watertec" className="callnow">Call Now</a>
                                </div>
                            </div>
                        </div>
                         <div className="col-md-4 mt-2">
                            <div className="card">
                                <img src={watertechproduct} className="card-img-top" alt="watertechproduct"/>
                                <div className="card-body">
                                    <h5 className="card-title mb-1">WATER TEC</h5>
                                    <p>Availabe at Uma Hardware</p>
                                    <a style={{color:"white"}} href="Watertec" className="callnow">Call Now</a>
                                </div>
                            </div>
                        </div>

                          <div className="col-md-4 mt-2">
                            <div className="card">
                                <img src={watertechproducts} className="card-img-top" alt="watertechproduct"/>
                                <div className="card-body">
                                    <h5 className="card-title mb-1">WATER TEC</h5>
                                    <p>Availabe at Uma Hardware</p>
                                    <a style={{color:"white"}} href="Watertec" className="callnow">Call Now</a>
                                </div>
                            </div>
                        </div>

                          <div className="col-md-4 mt-2">
                            <div className="card">
                                <img src={watertechproductsnew} className="card-img-top" alt="watertechproductsnew"/>
                                <div className="card-body">
                                    <h5 className="card-title mb-1">WATER TEC</h5>
                                    <p>Availabe at Uma Hardware</p>
                                    <a style={{color:"white"}} href="Watertec" className="callnow">Call Now</a>
                                </div>
                            </div>
                        </div>
                          <div className="col-md-4 mt-2">
                            <div className="card">
                                <img src={watertehnew} className="card-img-top" alt="watertechproductsnew"/>
                                <div className="card-body">
                                    <h5 className="card-title mb-1">WATER TEC</h5>
                                    <p>Availabe at Uma Hardware</p>
                                    <a style={{color:"white"}} href="Watertec" className="callnow">Call Now</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Watertec